'use client'

import Image from 'next/image'
import React, { ComponentProps } from 'react'

type Props = {
  code: '20250203' | '20250401'
  onClickWrapper: () => void
} & Partial<ComponentProps<typeof Image>>

export const EventBanner = ({ code, onClickWrapper, ...props }: Props) => {
  const src = code === '20250401' ? '/assets/podo/banner/together_m_20250401.png' : '/assets/podo/banner/together_m.png'
  return (
    <div role="banner" aria-label={`event-banner-${code}`} onClick={onClickWrapper} tabIndex={0}>
      <Image src={src} alt={`event banner ${code}`} width={400} height={549} className="w-full h-auto" {...props} />
    </div>
  )
}
